// MoamadContext.js
import React, { createContext, useContext, useState } from "react";

const MoamadContext = createContext();

export const MoamadProvider = ({ children }) => {
  const [moamadRep, setMoamadRep] = useState([]);

  const updateMoamadRep = (newMoamadRep) => {
    setMoamadRep(newMoamadRep);
  };

  return (
    <MoamadContext.Provider value={{ moamadRep, updateMoamadRep }}>
      {children}
    </MoamadContext.Provider>
  );
};

export const useMoamadContext = () => {
  return useContext(MoamadContext);
};
